module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Clothes/Crown-444494458be72aeb9b47dc102732ab6c.svg";